<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span>View Card Details</span>
    </h6>

    <PageTable
      :tableTitle="table.title"
      :apiUrl="table.apiUrl"
      :tableFields="table.fields"
      :appendedParams="table.filters"
      :key="tableKey"
      :sortOrder="[{ field: 'created_at', direction: 'desc' }]"
    />

    <div
      class="d-flex flex-row"
      v-if="cardTransactionData !== null && isLost && hasCardSellingModule"
    >
      <div class="p-2">
        <a-button type="link" @click="openCardPaymentDetails">
          Lost Card Details
        </a-button>
      </div>
    </div>
    <div
      style="
        position: absolute;
        bottom: 0px;
        right: 0px;
        width: -webkit-fill-available;
        background-color: #f2f2f2;
        padding: 10px;
      "
    >
      <div class="container mx-0 px-0">
        <div class="row">
          <div class="px-3 w-100 d-flex justify-content-between">
            <button
              class="btn btn-sm"
              style="margin-left: 8px"
              @click.prevent="closeDrawer"
            >
              Cancel
            </button>
            <button
              class="btn btn-primary btn-sm"
              v-if="
                isReceived &&
                hasCardSellingModule === 'true' &&
                !hasCardAssignmentModule
              "
              style="margin-left: 8px"
              @click="
                () => {
                  lostCardFormDrawer.visible = true;
                  lostCardFormViewMode = true;
                }
              "
            >
              Lost Card
            </button>
          </div>
        </div>
      </div>
    </div>
    <a-drawer
      :width="lostCardFormDrawer.width"
      :placement="lostCardFormDrawer.placement"
      :visible="lostCardFormDrawer.visible"
      @close="closeLostCardFormDrawer"
    >
      <LostCardForm
        :cardData="cardData"
        @closeDrawer="closeLostCardFormDrawer"
        :viewMode="lostCardFormViewMode"
      />
    </a-drawer>
    <a-drawer
      :width="cardPaymentDetailDrawer.width"
      :placement="cardPaymentDetailDrawer.placement"
      :visible="cardPaymentDetailDrawer.visible"
      @close="closeCardPaymentDetailDrawer"
    >
      <CardPaymentDetailForm
        :cardTransactionData="cardTransactionData"
        @closeDrawer="closeCardPaymentDetailDrawer"
        :viewMode="cardPaymentDetailViewMode"
      />
    </a-drawer>
  </div>
</template>

<script>
import PageTable from '../../components/Page/Table.vue';
import moment from 'moment-timezone';
import LostCardForm from '@/views/CardManagement/CardTransaction/LostCardForm';
import HTTPRequest from '@/controllers/httpRequest';
import CardPaymentDetailForm from '@/views/CardManagement/CardTransaction/CardPaymentDetailForm';
import { mapGetters } from 'vuex';

const ENV = process.env.VUE_APP_ENV;
const TIMEZONE = process.env.VUE_APP_TIMEZONE || 'Asia/Singapore';

export default {
  components: {
    PageTable,
    LostCardForm,
    CardPaymentDetailForm
  },
  name: 'CardHistory',
  props: {
    cardData: Object,
    viewMode: Boolean
  },
  data() {
    return {
      cardTransaction: null,
      hasCardAssignmentModule: false,
      hasCardSellingModule: false,
      table: {
        title: 'Card History',
        apiUrl: '/api/v1/clp_card_logs/' + this.cardData.id,
        fields: [
          { name: 'action', title: 'Action' },
          {
            name: 'created_at',
            title: 'Date',
            formatter(date) {
              if (moment(date).isValid()) {
                if (ENV === 'development') {
                  return moment(date).format('MM/DD/YYYY');
                } else {
                  return moment.utc(date).tz(TIMEZONE).format('MM/DD/YYYY');
                }
              }
              return null;
            }
          },
          {
            name: 'created_at',
            title: 'Time',
            formatter(date) {
              if (moment(date).isValid()) {
                return moment(date).tz(moment.tz.guess()).format('hh:mm A');
              }
              return null;
            }
          }
        ],
        filters: {
          module: null,
          action: null
        }
      },
      tableKey: 0,
      lostCardFormViewMode: true,
      cardPaymentDetailViewMode: true,
      lostCardFormDrawer: {
        visible: false,
        width: 480,
        placement: 'right'
      },
      cardPaymentDetailDrawer: {
        visible: false,
        width: 480,
        placement: 'right'
      }
    };
  },
  methods: {
    async getCardAssignmentFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_ASSIGNMENT_FEATURE`
      );

      if (response.account_id) {
        this.hasCardAssignmentModule = response.value;
      }
    },
    async openCardPaymentDetails() {
      if (!this.cardTransaction) {
        await this.getCardTransaction();
      }
      this.cardPaymentDetailViewMode = true;
      this.cardPaymentDetailDrawer.visible = true;
    },
    async getCardSellingFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_SELLING_FEATURE`
      );

      if (response.account_id) {
        this.hasCardSellingModule = response.value == 'true';
      }
    },
    async getCardTransaction() {
      const cardId = this.cardData?.id;
      this.cardTransaction = null;
      if (cardId) {
        const data = await HTTPRequest.getRequest(
          '/api/v1/card_transactions/card/' + cardId
        );
        if (data.id) {
          this.cardTransaction = data;
        } else {
          this.cardTransaction = null;
        }
      }
    },

    async getCard() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/cards/' + this.cardData.id + '/card_type'
      );
      const isLost = data?.cardStatus?.status_code === 'CARD_LOST';
      if (isLost) {
        this.closeDrawer(true);
      }
    },
    clearData() {
      this.cardTransaction = null;
    },
    closeCardPaymentDetailDrawer(successTransaction = false) {
      if (successTransaction) {
        this.$emit('closeDrawer', null);
        this.closeDrawer(successTransaction);
      }
      this.cardPaymentDetailDrawer.visible = false;
    },
    closeDrawer(successTransaction = false) {
      this.$emit('closeDrawer', successTransaction);
      this.lostCardFormDrawer.visible = false;
      this.cardPaymentDetailDrawer.visible = false;
      this.clearData();
    },
    closeLostCardFormDrawer(successTransaction = false) {
      this.getCard();
      this.lostCardFormDrawer.visible = false;
      if (successTransaction) {
        this.closeDrawer(successTransaction);
      }
    }
  },
  async created() {
    await this.getCardAssignmentFeature();
    await this.getCardTransaction();
    await this.getCardSellingFeature();
  },
  computed: {
    ...mapGetters({
      selectedActions: 'getModuleSelectedActions'
    }),
    isReceived() {
      return this.cardData?.cardStatus?.name === 'Received';
    },
    isLost() {
      return this.cardData?.cardStatus?.name === 'Lost';
    },
    cardTransactionData() {
      return this.cardTransaction ?? null;
    }
  },
  mounted() {
    this.selectedActions = this.$store.getters.getModuleSelectedActions;
  },
  watch: {
    cardData: function (data) {
      if (data && data.id && this.table && this.table.apiUrl) {
        this.getCardTransaction();
        this.table.apiUrl = '/api/v1/clp_card_logs/' + data.id;
        this.tableKey++;
      }
    }
  }
};
</script>

<style scoped></style>
